import type { Quiz } from '@efdigital/ll-addon-data';
import { selectValue } from '@efdigital/ll-addon-ui/modifiers/select-value';
import { uniqueId } from '@ember/helper';
import { on } from '@ember/modifier';
import Component from '@glimmer/component';

import { CategoryIcon } from './category-icon.gts';

interface Signature {
  Args: {
    /**
     * The quiz that the question belongs to.
     */
    quiz: Quiz;

    /**
     * The category cid that the score belongs to. Use null or empty string for grand total only.
     */
    category: string | null | undefined;

    /**
     * The score for the category.
     */
    score: number | null | undefined;

    /**
     * The function to call when the score or category changes.
     */
    onChange: (score: number, category: string) => void;

    /**
     * The class to add to the labels.
     */
    labelClass?: string;
  };
  Element: HTMLDivElement;
}

export class CategoryScore extends Component<Signature> {
  setScore = (event: Event) => {
    const target = event.target as HTMLInputElement;
    this.args.onChange(parseInt(target.value) || 0, this.args.category || '');
  };

  setCategory = (event: Event) => {
    const target = event.target as HTMLSelectElement;
    this.args.onChange(this.currentScore, target.value);
  };

  get currentScore(): number {
    return this.args.score || 0;
  }

  get selectedCategory(): string {
    return this.args.category || '';
  }

  <template>
    {{#let (uniqueId) as |uniqueId|}}
      <div class="row g-2" ...attributes>
        <div class="col-4">
          <label
            class="form-label {{@labelClass}}"
            for="{{uniqueId}}-score"
          >Score</label>
          <input
            id="{{uniqueId}}-score"
            type="number"
            class="form-control"
            value={{@score}}
            {{on "change" this.setScore}}
          />
        </div>

        <div class="col-8">
          <label
            class="form-label {{@labelClass}}"
            for="{{uniqueId}}-category"
          >Category</label>
          {{#if @quiz.categories.length}}
            <div class="input-group">
              <span class="input-group-text"><CategoryIcon
                  @category={{this.selectedCategory}}
                  @categories={{@quiz.categories}}
                /></span>
              <select
                id="{{uniqueId}}-category"
                class="form-select"
                {{selectValue this.selectedCategory}}
                {{on "change" this.setCategory}}
              >
                <optgroup>
                  <option value="">Grand Total only</option>
                </optgroup>
                <optgroup label="Categories">
                  {{#each @quiz.categories as |category|}}
                    <option value={{category.cid}}>{{category.title}}</option>
                  {{/each}}
                </optgroup>
              </select>
            </div>
          {{else}}
            <iconify-icon icon="ph:sigma" />&nbsp;<span
              class="form-control"
              disabled
            >Grand Total</span>
          {{/if}}
        </div>
      </div>
    {{/let}}
  </template>
}
